import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerSW } from "virtual:pwa-register";
import { initSentry } from "./lib/sentry";
import { PostHogProvider } from "@posthog/react";
import { redactScreenTokensDeep } from "./lib/screenPrivacy";

// Initialize Sentry before rendering
initSentry();

// Register PWA service worker
registerSW({ immediate: true });

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogOptions = {
  api_host: import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com",
  defaults: "2026-01-30",
  // Stamp every event with the deploy environment so insights and alerts
  // can exclude staging. Same VITE_APP_ENV Sentry uses.
  loaded: (ph: { register: (p: Record<string, string>) => void }) =>
    ph.register({ env: import.meta.env.VITE_APP_ENV ?? "development" }),
  // Stadium-screen URLs carry the club's screen token; it must not end up in
  // $current_url / $pathname / referrers.
  before_send: <T,>(event: T) => (event ? redactScreenTokensDeep(event) : event),
} as const;

createRoot(document.getElementById("root")!).render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      <App />
    </PostHogProvider>
  ) : (
    <App />
  )
);
